import _ from "lodash"
import { Suspense, useContext } from "react"
import { Helmet } from "react-helmet-async"
import { Link, Route, Routes } from "react-router-dom"
import { useSession } from "source/shared/hooks/useSession"
import { NarrowLayout } from "source/Layout"
import Schedule from "./Schedule"
import ActivityAndInvolvement from "./ActivityAndInvolvement"
import useMyChurchCenter from "./hooks/useMyChurchCenter"
import { Avatar, Loading } from "source/shared/components"
import { WebBootContext } from "source/publishing/WebBoot"
import { RespondsToBlockoutNotification } from "source/services/shared"
import { Heading } from "@planningcenter/doxy-web"
import { Profile } from "./Profile"
import { MyNotes, MyNote } from "source/myChurchCenter/MyNotes"
import { useFlipperFeatureEnabled } from "source/shared/flipperFeatures"
import { ProfileAndHousehold } from "../myChurchCenter/Profile/ProfileAndHousehold"

export function MyChurchCenter() {
  const ROLLOUT_custom_fields = useFlipperFeatureEnabled(
    "ROLLOUT_custom_fields",
  )
  return (
    <Routes>
      <Route path="/notes/:noteId" element={<MyNote />} />
      <Route path="/notes" element={<MyNotes />} />
      <Route path="/profile/*" element={<Profile />} />

      {ROLLOUT_custom_fields && (
        <Route
          path="/profile-and-household/*"
          element={<ProfileAndHousehold />}
        />
      )}
      <Route path="*" element={<MyChurchCenterLayout />} />
    </Routes>
  )
}

export function MyChurchCenterLayout() {
  const {
    data: {
      attributes: { first_name, avatar_url },
    },
  } = useSession(true)

  const {
    builtInPages: { calendar, groups, registrations, giving },
    abilities: { services: servicesAbilities } = {},
  } = useContext(WebBootContext)

  const {
    data: { activityDates, pendingItems },
    refetch: reloadMyChurchCenter,
  } = useMyChurchCenter()

  const pauseToAllowReplicationBetweenServicesAndDynamoDB = setTimeout

  const refreshMyChurchCenter = () =>
    pauseToAllowReplicationBetweenServicesAndDynamoDB(
      reloadMyChurchCenter,
      1000,
    )

  const hasServices = _.some(servicesAbilities)
  const hasGroups = groups === "published"
  const hasRegistrations = registrations === "published"
  const hasCalendar = calendar === "published"
  const hasGiving = giving === "published"

  return (
    <NarrowLayout>
      <Helmet title="Me" />
      <RespondsToBlockoutNotification />
      <div className="d-f jc-sb ai-c mb-3">
        <div className="d-f ai-c">
          <div className="avatar mr-2 w-8 h-8 o-h">
            <Avatar url={avatar_url} alt={`profile image for ${first_name}`} />
          </div>
          <div className="df-c">
            <Heading level={1} size={2} text={`Hello, ${first_name}!`} />
            <Link to="/me/profile" className="f-2">
              My profile and settings
            </Link>
          </div>
        </div>
        <div>
          <Link to="/logout" className="f-2">
            Logout
          </Link>
        </div>
      </div>
      <Schedule
        hasCalendar={hasCalendar}
        hasGroups={hasGroups}
        hasRegistrations={hasRegistrations}
        hasServices={hasServices}
        refreshMyChurchCenter={refreshMyChurchCenter}
        scheduleItems={{ activityDates, pendingItems }}
      />
      <Suspense fallback={<Loading />}>
        <ActivityAndInvolvement
          hasGiving={hasGiving}
          hasGroups={hasGroups}
          hasRegistrations={hasRegistrations}
        />
      </Suspense>
    </NarrowLayout>
  )
}
